// Keep this list aligned with LeaseRecordsWhitespaceFilter on the API. These
// properties are edited as multiline text, even when their current value is one line.
const formattedFields = new Set([
    'notes',
    'legaldescription',
    'maplegaldescription',
    'tractdescription',
    'remarknotes',
    'note',
    'remindnote',
    'isdscr',
    'lettertext',
    'comm1',
    'comm2',
    'attach',
]);

export const normalizeLeaseRecordWhitespace = <T>(value: T, field = ''): T => {
    if (typeof value === 'string') {
        return (formattedFields.has(field.toLowerCase()) ? value : value.trim()) as unknown as T;
    }
    if (Array.isArray(value)) {
        return value.map((item) => normalizeLeaseRecordWhitespace(item, field)) as unknown as T;
    }
    // Do not transform dates, uploads, or other non-JSON values.
    if (value && Object.getPrototypeOf(value) === Object.prototype) {
        const normalized: Record<string, unknown> = {};
        Object.entries(value).forEach(([key, item]) => {
            normalized[key] = normalizeLeaseRecordWhitespace(item, key);
        });
        return normalized as T;
    }
    return value;
};



// WEBPACK FOOTER //
// ./src/components/leases/leaseRecordWhitespace.ts